import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

const Layout = React.memo(() => {
  // State to manage product tour visibility
  const [isTourOpen, setIsTourOpen] = useState(false);

  // Define the steps for the product tour

  return (
    <div className="flex flex-col min-h-screen bg-[#121316]">
      {/* Top Navigation Bar */}
      <Navbar />

      <div className="flex w-full h-[calc(100vh-68px)] overflow-x-hidden">
        {/* Sidebar - Only visible on large screens */}
        <div className="hidden lg:block">
          <Sidebar setIsTourOpen={setIsTourOpen} />
        </div>

        {/* Main Content Section */}
        <div className="bg-[#121316] h-auto text-white flex flex-1 flex-col min-w-0">
          <Outlet />
        </div>
      </div>

      {/* Product Tour Component */}
      {/* <ProductTour
        steps={tourSteps}
        isOpen={isTourOpen}
        onClose={() => setIsTourOpen(false)}
      /> */}
    </div>
  );
});

export default Layout;
